'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoClosedCaptioning = function IoClosedCaptioning(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm0 5h40v30h-40v-30z m36.3 15c0-2.1 0-3.4-0.4-6.2s-1.8-4.4-4.6-4.7-7.1-0.4-10.8-0.4h-1c-3.7 0-8 0-10.8 0.4s-4.3 1.8-4.6 4.6-0.3 4.2-0.3 6.3 0.1 3.7 0.3 6.3 1.4 4.3 4.6 4.6 7.5 0.4 11.3 0.4 8.2 0 11.3-0.4 4.5-2.1 4.6-4.6 0.4-4.2 0.4-6.3z m-7.2 2.2v-0.3h4.1c0 2.1-0.5 3.7-1.5 4.8s-2.5 1.7-4.7 1.7c-1.1 0-2.1-0.2-2.9-0.4s-1.4-0.7-1.9-1.4-0.9-1.4-1.2-2.5-0.4-2.4-0.4-4 0.3-3.1 0.6-4.2 0.7-1.9 1.3-2.5 1.3-1.1 2.1-1.4 1.7-0.4 2.7-0.4c1.9 0 3.4 0.6 4.4 1.7s1.5 2.9 1.5 4.8h-4.1v-0.1c0-1.5-0.9-2.5-2.1-2.5s-1.9 0.8-2.2 2.3c0 0-0.1 0.9-0.1 2.3s0.1 2.2 0.1 2.2c0.1 1.3 1 2.2 2.2 2.2s2.1-0.7 2.1-2.2v-0.1z m-13.9 0v-0.3h4.2c0 2.1-0.6 3.7-1.5 4.8s-2.5 1.7-4.8 1.7c-1.1 0-2-0.2-2.8-0.4s-1.4-0.7-1.9-1.4-1-1.4-1.2-2.5-0.4-2.4-0.4-4 0.2-3.1 0.5-4.2 0.7-1.9 1.4-2.5 1.3-1.1 2.1-1.4 1.7-0.4 2.6-0.4c2 0 3.5 0.6 4.5 1.7s1.5 2.9 1.5 4.8h-4.1v-0.1c0-1.5-0.9-2.5-2.1-2.5s-2 0.8-2.2 2.3c0 0-0.1 0.9-0.1 2.3s0.1 2.2 0.1 2.2c0.1 1.3 1 2.2 2.1 2.2s2.1-0.7 2.1-2.2v-0.1z' })
        )
    );
};

exports.default = IoClosedCaptioning;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/closed-captioning.js
// module id = 1995
// module chunks = 0